let debounceTimer: NodeJS.Timer;
export default function debounce(func: Function, delay: number) {
	return function (this: any) {
		let context = this;
		let args = arguments;

		debounceTimer && clearTimeout(debounceTimer);

		debounceTimer = global.setTimeout(() => {
			func.apply(context, args);
		}, delay);

		return debounceTimer;
	};
}
